import gql from "graphql-tag";

export const fragment = gql`
fragment createcertifiedplanttype on CreateCertifiedPlantType {
  message
  statusCode
  plantId
}
`